export default __webpack_public_path__ + "static/media/invoiage-transparent-logo-small.be77355f.png";